import React, { useRef, useState } from "react";
import { useGLTF, useTexture, Html, Environment, CubeCamera } from "@react-three/drei";
import { useControls } from "leva";
import * as THREE from "three";
import Meshpoint from "./Meshpoint";

export default function Appartement(props) {
  const { nodes } = useGLTF("./appartement/appartement.glb"); {/**Load model */ }
  const salonComplet = useRef()
  const chaiseCuisine = useRef()
  const kitchen = useRef()
  const sol = useRef()
  {/*---------------------------------- Leva ----------------------------------*/ }
  const { transparency, environment } = useControls({
    transparency: {
      value: 0.5,
      min: 0,
      max: 1,
      step: 0.001,
    },
    environment: {
      value: 1,
      min: 0,
      max: 1,
      step: 0.001
    }
  });
  {/* -------------------------------- Fin Leva -------------------------------- */ }



  {/* -------------------------------- Loding all Textures -------------------------------- */ }
  const arbreTexture = useTexture("./appartement/arbre.jpg");
  arbreTexture.flipY = false;

  const arbreOpacityTexture = useTexture("./appartement/arbre_opacity.png");
  arbreOpacityTexture.flipY = false;

  const cadreTexture = useTexture("./appartement/cadre.jpg");
  cadreTexture.flipY = false;

  const chaiseCuisineTexture = useTexture("./appartement/chaise_cuisine.jpg");
  chaiseCuisineTexture.flipY = false;
  const chaiseCuisine2Texture = useTexture("./appartement/chaise_cuisine_2.jpg");
  chaiseCuisine2Texture.flipY = false;

  const chambreEnfantTexture = useTexture("./appartement/chambre_enfant.jpg");
  chambreEnfantTexture.flipY = false;

  const chambreParentsTexture = useTexture("./appartement/chambre_parents.jpg");
  chambreParentsTexture.flipY = false;

  const decoration1Texture = useTexture("./appartement/decoration_1.jpg");
  decoration1Texture.flipY = false;

  const decoration2Texture = useTexture("./appartement/decoration_2.jpg");
  decoration2Texture.flipY = false;

  const jardinTexture = useTexture("./appartement/jardin.jpg");
  jardinTexture.flipY = false;

  const kitchenTexture = useTexture("./appartement/kitchen.jpg");
  kitchenTexture.flipY = false;

  const kitchen2Texture = useTexture("./appartement/kitchen_2.jpg");
  kitchen2Texture.flipY = false;

  const meubleSalonTexture = useTexture("./appartement/meuble_salon.jpg");
  meubleSalonTexture.flipY = false;

  const murMaisonTexture = useTexture("./appartement/mur_maison.jpg");
  murMaisonTexture.flipY = false;

  const plafondTexture = useTexture("./appartement/plafond.jpg");
  plafondTexture.flipY = false;

  const resteHome1Texture = useTexture("./appartement/reste_home.jpg");
  resteHome1Texture.flipY = false;

  const reflexionTexture = useTexture("./appartement/Reflection.jpg");
  reflexionTexture.flipY = false;

  const reflexionRoughnessTexture = useTexture("./appartement/reflection_roughness.jpg");
  reflexionRoughnessTexture.flipY = false;

  const resteHome2Texture = useTexture("./appartement/reste_home_2.jpg");
  resteHome2Texture.flipY = false;

  const salonCompletTexture = useTexture("./appartement/salon_complet.jpg");
  salonCompletTexture.flipY = false;

  const salonCompletGrayTexture = useTexture("./appartement/salon_complet_2.jpg");
  salonCompletGrayTexture.flipY = false;

  const salleBainTexture = useTexture("./appartement/salle_bain.jpg");
  salleBainTexture.flipY = false;

  const solTexture = useTexture("./appartement/sol.jpg");
  solTexture.flipY = false;

  const sol2Texture = useTexture("./appartement/sol_2.jpg");
  sol2Texture.flipY = false;

  const vitreCadreTexture = useTexture("./appartement/vitre_cadre.jpg");
  vitreCadreTexture.flipY = false;

  const vitreCadreOpacityTexture = useTexture("./appartement/vitre_cadre_opacity.png");
  vitreCadreOpacityTexture.flipY = false;
  {/* ------------------------ Fin loading all textures ------------------------ */ }

  {/* ---------------------------- Load Appartement ---------------------------- */ }
  return (
    <>
      <group {...props} dispose={null}>
        <CubeCamera resolution={256} frames={Infinity}>
          {(texture) => (
            <>
              <Environment map={texture} />
              <mesh geometry={nodes.sol.geometry} position={[0.68, 0, -0.13]} ref={sol}>
                <meshStandardMaterial
                  map={solTexture}
                  roughness={0.2}
                  envMapIntensity={environment} />
                <Meshpoint
                  meshRef={sol}
                  meshTexture1={solTexture}
                  meshTexture2={sol2Texture}
                  position={[-2, 0, -1]}
                  classNameTexture1='sol-brown'
                  classNameTexture2='sol-gray' />
              </mesh>
              <mesh geometry={nodes.reflection.geometry} position={[-4.34, 0.74, -3]}>
                <meshStandardMaterial
                  map={reflexionTexture}
                  roughnessMap={reflexionRoughnessTexture}
                  envMapIntensity={environment}
                />
              </mesh>

            </>
          )}

        </CubeCamera>
        <mesh
          geometry={nodes.meuble_salon.geometry} position={[-1.04, 0.41, -2.21]}>
          <meshBasicMaterial
            side={THREE.DoubleSide}
            map={meubleSalonTexture}
          />
        </mesh>
        <mesh
          ref={kitchen}
          geometry={nodes.kitchen.geometry}
          position={[-4.71, 0.92, -0.04]}>
          <meshBasicMaterial
            map={kitchenTexture}
            side={THREE.DoubleSide}
          />
          <Meshpoint
            meshRef={kitchen}
            meshTexture1={kitchenTexture}
            meshTexture2={kitchen2Texture}
            position={[-1, -0.5, 0.8]}
            classNameTexture1='kitchen-brown'
            classNameTexture2='kitchen-gray' />
        </mesh>
        <mesh geometry={nodes.decoration_2.geometry} position={[-0.87, 1.16, -1.04]}>
          <meshBasicMaterial map={decoration2Texture} />
        </mesh>
        <mesh geometry={nodes.mur_maison.geometry} position={[0.36, 1.57, 0.66]}>
          <meshBasicMaterial map={murMaisonTexture} />
        </mesh>
        <mesh geometry={nodes.reste_home.geometry} position={[-1.52, 0.64, -0.54]}>
          <meshBasicMaterial map={resteHome1Texture} />
        </mesh>

        <mesh geometry={nodes.jardin.geometry} position={[-1.62, 0.37, -7.46]}>
          <meshBasicMaterial map={jardinTexture} />
        </mesh>
        <mesh
          geometry={nodes.chambre_parents.geometry} position={[4.4, 0.39, -3.86]}>
          <meshBasicMaterial map={chambreParentsTexture} />
        </mesh>
        <mesh
          geometry={nodes.reste_home_2.geometry} position={[-1.64, 0.62, -5.82]}>
          <meshBasicMaterial map={resteHome2Texture} side={THREE.DoubleSide} />
        </mesh>
        <mesh
          geometry={nodes.salle_bain.geometry} position={[1.63, 0.92, 1.96]}>
          <meshBasicMaterial map={salleBainTexture} side={THREE.DoubleSide} />
        </mesh>
        <mesh geometry={nodes.chambre_enfant.geometry} position={[4.37, 0.37, 2.86]}>
          <meshBasicMaterial map={chambreEnfantTexture} />
        </mesh>
        <mesh geometry={nodes.vitre_1.geometry} position={[1.16, 1.48, -0.65]}>
          <meshBasicMaterial alphaMap={vitreCadreOpacityTexture} transparent />
        </mesh>
        <mesh
          geometry={nodes.chaise_cuisine.geometry}
          position={[-4.35, 0.35, -3.08]}
          ref={chaiseCuisine}>
          <meshBasicMaterial map={chaiseCuisineTexture} toneMapped={false} />
          <Meshpoint
            meshRef={chaiseCuisine}
            meshTexture1={chaiseCuisineTexture}
            meshTexture2={chaiseCuisine2Texture}
            position={[0.7, 0.6, 1]}
            classNameTexture1='chaise-cuisine-gray'
            classNameTexture2='chaise-cuisine-white' />
        </mesh>

        <mesh
          geometry={nodes.decoration_1.geometry} position={[3.28, 1.36, 1.81]}>
          <meshBasicMaterial map={decoration1Texture} />
        </mesh>
        <mesh geometry={nodes.plafond.geometry} position={[0.86, 2.46, -0.49]}>
          <meshBasicMaterial map={plafondTexture} />
        </mesh>
        <mesh
          geometry={nodes.vitres_2.geometry} position={[1.1, 1.39, -1.23]}>
          <meshBasicMaterial map={vitreCadreTexture} />
        </mesh>
        <mesh geometry={nodes.cadre.geometry} position={[-1.97, 1.29, -3.81]}>
          <meshBasicMaterial map={cadreTexture} />
        </mesh>
        <mesh
          geometry={nodes.arbre.geometry} position={[0.36, 1.93, -7.17]}>
          <meshBasicMaterial
            map={arbreTexture}
            transparent
            alphaMap={arbreOpacityTexture}
            side={THREE.DoubleSide}
            alphaTest={transparency}
          />
        </mesh>
        <mesh
          geometry={nodes.salon_complet.geometry}
          position={[0.66, 0.41, -2.8]}
          ref={salonComplet}
        >
          <meshBasicMaterial map={salonCompletTexture} />
          {/* ---------------------------- Texture Selector ---------------------------- */}
          <Meshpoint
            meshRef={salonComplet}
            meshTexture1={salonCompletTexture}
            meshTexture2={salonCompletGrayTexture}
            position={[-1.5, 0.3, 0.5]}
            classNameTexture1='salon-texture-brown'
            classNameTexture2='salon-texture-gray' />
          {/* -------------------------- Fin texture Selector -------------------------- */}
        </mesh>
        <mesh geometry={nodes.spots.geometry} position={[0.65, 2.37, -0.25]} material={nodes.spots.material} />

        <mesh geometry={nodes.emessive.geometry} position={[0.65, 2.37, -0.25]}>
          <meshStandardMaterial
            color={[1, 1, 3]}
            emissive="white"
            emissiveIntensity={5}
            toneMapped={false} />
        </mesh>

      </group>
    </>
  );
}

useGLTF.preload("/appartement.glb");
{/* --------------------------- Fin load Apprtement -------------------------- */ }
